import React from 'react';
import { Popup, Position } from 'devextreme-react/popup';
import Form, { SimpleItem, Item, Label, GroupItem, ButtonItem } from 'devextreme-react/form';
import ServiceUsers from '../../../../api/services/ServiceUsers'

import './PopupShuttlesUserSettings.scss'


// callbacks
//      onInitialized: callback
//      onUpdate: callback
//      onLoadError: callback


const defaultSettings  = {
    UserId: sessionStorage.getItem('currentUserId'),
    DefaultViewId: -1,
    DefaultFilterId: -1,
    ShowSelectedCell: false,
    UseAdvancedFiltering: false,
}

class PopupShuttlesUserSettings extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            userSettingsShuttles: {}
        }

        this.popupInstance = null;

        this.checkBoxShowSelectedCellInstance = null;
        this.checkBoxUseAdvancedFilteringInstance = null;

        this.dataLoaded = false;

        this.userSettings = {
            UserId: parseInt(sessionStorage.getItem("currentUserId"), 10),
            DefaultViewId: -1,
            DefaultFilterId: -1,
            ShowSelectedCell: false,
            UseAdvancedFiltering: false,
        }
    } 


    // CALLBACKS
    onInitialized = (instance) => {
        if (this.props.onInitialized) {
            this.props.onInitialized(instance);  // callback
        }
    }

    onLoadError = () => {
        if (this.props.onLoadError) {
            this.props.onLoadError();  // callback
        }
    }

    onUpdate = (elementId, value) => {
        if (this.props.onUpdate) {
            this.props.onUpdate(elementId, value);  // callback
        }
    }

    // POPUP
    popup_OnInitialized = (e) => {
        this.popupInstance = e.component;
        this.onInitialized(e.component);
    }

    popup_OnShown = async (e) => {
        await this.loadData();
    }

    popup_OnHidden = async (e) => {
        this.dataLoaded = false;
    }

    loadData = async () => {
        var settings = await ServiceUsers.getUserSettingsShuttlesByUserId(parseInt(sessionStorage.getItem("currentUserId"), 10));
        settings = (settings !== null ? settings : this.userSettings);
        if (!settings.hasOwnProperty("error")) {
            this.setState({ userSettingsShuttles: settings });
            this.dataLoaded = true;
        } else {
            this.onLoadError();
        }
    }

    saveData = async (elementId, value) => {
        var success = await ServiceUsers.setUserSettingsShuttles(this.state.userSettingsShuttles);
        if (!success.hasOwnProperty("error")) {
            if (success === true) {
                // trigger callback
                this.onUpdate(elementId, value);
            } else {
                this.onLoadError();
            }
        } else {
            this.onLoadError();
        }
    }

    userSettingChanged = async (e) => {
        if (this.dataLoaded) {
            await this.saveData(e.element.id, e.value);
        }
    }

    checkBoxUseAdvancedFiltering_OnInitialized = (e) => {
        this.checkBoxUseAdvancedFilteringInstance = e.component;
    }

    checkBoxUseAdvancedFiltering_OnValueChanged = (e) => {
        this.userSettingChanged(e);
    }

    checkBoxShowSelectedCell_OnInitialized = (e) => {
        this.checkBoxShowSelectedCellInstance = e.component;
    }

    checkBoxShowSelectedCell_OnValueChanged = (e) => {
        this.userSettingChanged(e);
    }
 
    render() {
        return (
            <React.Fragment>
                <Popup
                    dragEnabled={false}
                    hideOnOutsideClick={true}
                    title='Settings'
                    width={360}
                    height={190}
                    shading={false}
                    showTitle={false}
                    onInitialized={this.popup_OnInitialized}
                    onShown={this.popup_OnShown}
                    onHidden={this.popup_OnHidden}
                >
                    <Position
                        my="right top"
                        at="right bottom"
                        of="#toolBarShuttles"
                    />
                    <Form
                        id={'form'}
                        defaultFormData={defaultSettings}
                        formData={this.state.userSettingsShuttles}
                        labelLocation={'right'}
                        colCount={1}
                        validationGroup="validationGroupForm"
                    >
                        <GroupItem caption={'Behaviour'}>
                            <SimpleItem
                                dataField={"ShowSelectedCell"}
                                editorType="dxCheckBox"
                                editorOptions={{
                                    text: 'Highlight selected cell',
                                    elementAttr: { id: 'checkBoxShowSelectedCell' },
                                    onValueChanged: this.checkBoxShowSelectedCell_OnValueChanged
                                }}
                            >
                                <Label visible={false} />
                            </SimpleItem>
                            <SimpleItem
                                dataField={"UseAdvancedFiltering"}
                                editorType="dxCheckBox"
                                editorOptions={{
                                    text: 'Use advanced filtering',
                                    elementAttr: { id: 'checkBoxUseAdvancedFiltering' },
                                    onValueChanged: this.checkBoxUseAdvancedFiltering_OnValueChanged
                                }}
                            >
                                <Label visible={false} />
                            </SimpleItem>
                        </GroupItem>
                    </Form>
                </Popup>
            </React.Fragment>
        );

    }

}

export default PopupShuttlesUserSettings

